import React from "react";

function Manual() {
    function Iframe(props) {
        return (<div onContextMenu={(e) => e.preventDefault()} dangerouslySetInnerHTML={{ __html: props.iframe ? props.iframe : "" }} />);
    }
    return <Iframe iframe={`<iframe id="center-iframe" style="width: 100%; height: 100vh;" src=${"./assets/Manual.pdf"}></iframe>`} />
}
export default Manual;